import { Grid, Typography } from '@material-ui/core'
import React, { ComponentProps, PropsWithChildren } from 'react'
import {
  CurrencyValue,
  ListingHeading,
  StyledBottomContent,
  StyledBottomRow,
  StyledCenterContent,
  StyledCenterRow,
  StyledDisclaimerContent,
  StyledPA,
  StyledPercentage,
  StyledTopContent,
  StyledTopRow,
  StyledValue,
} from './styledFeatureListing'

export type ListingWrapperProps = ComponentProps<typeof Grid> & {
  //
}

export type ListingHeadingProps = ComponentProps<typeof Grid> & {
  //
}

export type ListingTopRowProps = ComponentProps<typeof Grid> & {
  //
}

export type ListingCenterRowProps = ComponentProps<typeof Grid> & {
  //
}

export type ListingBottomRowProps = ComponentProps<typeof Grid> & {
  //
}

export type ListingTopProps = ComponentProps<typeof Grid> & {
  value?: string
  percentage?: false | true
  asterisk?: false | true
}

export type ListingCenterProps = ComponentProps<typeof Grid> & {
  value?: string
  percentage?: false | true
  asterisk?: false | true
}

export type ListingBottomProps = ComponentProps<typeof StyledTopContent> & {
  asterisk?: false | true
}



export type ListingProps =
  | (
    {
      topRow?: never
      centerRow?: never
      bottomRow?: never
      topContent?: never
      centerContent?: never
      bottomContent?: never
      disclaimerContent?: never
    } & ListingWrapperProps
  )
  | (
    {
      topRow: true
      centerRow?: never
      bottomRow?: never
      topContent?: never
      centerContent?: never
      bottomContent?: never
      disclaimerContent?: never
    } & ListingTopRowProps
  )
  | (
    {
      topRow?: never
      centerRow?: true
      bottomRow?: never
      topContent?: never
      centerContent?: never
      bottomContent?: never
      disclaimerContent?: never
    } & ListingCenterRowProps
  )
  | (
    {
      topRow?: never
      centerRow?: never
      bottomRow?: true
      topContent?: never
      centerContent?: never
      bottomContent?: never
      disclaimerContent?: never
    } & ListingBottomRowProps
  )
  | (
    {
      topRow?: never
      centerRow?: never
      bottomRow?: never
      topContent?: true
      centerContent?: never
      bottomContent?: never
      disclaimerContent?: true
    } & ListingTopProps
  )
  | (
    {
      topRow?: never
      centerRow?: never
      bottomRow?: never
      topContent?: never
      centerContent?: true
      bottomContent?: never
      disclaimerContent?: never
    } & ListingCenterProps
  )
  | (
    {
      topRow?: never
      centerRow?: never
      bottomRow?: never
      topContent?: never
      centerContent?: never
      bottomContent?: true
      disclaimerContent?: never
    } & ListingBottomProps
  )

export const Listing: React.FC<PropsWithChildren<ListingProps>> = ({
  topRow,
  centerRow,
  bottomRow,
  topContent,
  centerContent,
  bottomContent,
  disclaimerContent,
  children,
  ...props
}) => {
  if (centerRow) {
    return (
      <StyledCenterRow
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        xs={12}
      >
        {children}
      </StyledCenterRow>
    )
  }

  if (topRow) {
    return (
      <StyledTopRow
        item
        xs={12}
      >
        <Grid
          container
          direction="column"
          alignItems="flex-start"
          justifyContent="center"
        >
          {<Typography>{children}</Typography>}
        </Grid>
      </StyledTopRow>
    )
  }

  if (bottomRow) {
    return (
      <StyledBottomRow
        item
        xs={12}
      >
        <Grid
          container
          direction="column"
          alignItems="flex-start"
          justifyContent="center"
        >
          <Typography>{children}</Typography>
        </Grid>
      </StyledBottomRow>
    )
  }

  if (centerContent) {
    return (
      <CenterContent {...props}>{children}</CenterContent>
    )
  }

  if (topContent) {
    return (
      <TopContent {...props}>{children}</TopContent>
    )
  }

  if (bottomContent) {
    return (
      <BottomContent {...props}>{children}</BottomContent>
    )
  }

  if (disclaimerContent) {
    return (
      <DisclaimerContent {...props}>{children}</DisclaimerContent>
    )
  }

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      {...props}
    >
      {children}
    </Grid>

  )
}

const CenterContent: React.FC<PropsWithChildren<ListingTopProps>> = ({ value, asterisk, percentage, children, ...props }) => {
  return (
    <StyledCenterContent
      item
      xs={6}
      sm={3}
      justifyContent="center"
      alignItems="center"
      {...props}
    >
      <Grid
        container
        direction="column"
        alignItems="center"
      >
        {percentage ? <Percentage>{value}</Percentage> : <CurrencyValue><span>$</span>{value}</CurrencyValue>}
        <ListingHeading >{children} {asterisk && <span>*</span>}</ListingHeading>
      </Grid>
    </StyledCenterContent>
  )
}

const Percentage: React.FC<PropsWithChildren<{}>> = ({ children }) => {
  return (

    <StyledValue>
      {children}
      <span>
        <StyledPercentage>%</StyledPercentage>
        <StyledPA>p.a.</StyledPA>
      </span>

    </StyledValue>
  )
}

const TopContent: React.FC<PropsWithChildren<ListingBottomProps>> = ({ asterisk, children }) => {
  return (
    <StyledTopContent>{asterisk && <span>*</span>}{children}</StyledTopContent>
  )
}

const BottomContent: React.FC<PropsWithChildren<ListingTopProps>> = ({ asterisk, children }) => {
  return (
    <StyledBottomContent>{asterisk && <span>*</span>}{children}</StyledBottomContent>
  )
}

const DisclaimerContent: React.FC<PropsWithChildren<ListingTopProps>> = ({ asterisk, children }) => {
  return (
    <StyledDisclaimerContent>{asterisk && <span>*</span>}{children}</StyledDisclaimerContent>
  )
}
